import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligon';
const args = {};

export class Oligon extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
